export default {"src":"/_next/static/image/public/images/fb.57d7dd522eb7d0ff49113dc4bee2d3b5.svg","height":37,"width":36};